<template>
    <v-layout column>
        <v-layout style="margin-top: 30px;" align-center>
            <v-text-field style="max-width: 250px;"
                          color="secondary"
                          v-model="phone"
                          clearable
                          placeholder="Поиск по номеру телефона"
                          prepend-inner-icon="mdi-magnify"/>

            <v-btn class="secondary"
                   @click="search"
                   style="width: 110px; height: 40px; margin: -10px 0 0 20px; border-radius: 8px;">Найти
            </v-btn>

            <div class="xls-button" v-ripple @click="saveXls">
                <v-layout align-center justify-center fill-height>
                    <label class="subtitle-1 font-weight-bold">
                        Скачать данные в .xls
                    </label>
                </v-layout>
            </div>
        </v-layout>

        <v-layout>
            <label class="subtitle-1"
                   style="margin-top: 20px; width: 400px;">{{items.length ? usersCountLabel : 'Покупатели не
                найдены.'}}</label>

            <v-checkbox v-model="approve"
                        color="accent"
                        label="С активным запросом на верификацию"/>
        </v-layout>

        <v-data-table :headers="headers"
                      :items="items"
                      hide-default-footer
                      disable-sort
                      :mobile-breakpoint="200"
                      fixed-header
                      loading-text="Загрузка"
                      :height="height - 320"
                      :items-per-page="perPage"
                      color="secondary"
                      :loading="loading"
                      class="scroll-y"
                      v-if="items.length"
                      style="margin-top: 20px; width: 100%; margin-left: -15px;">
            <template v-slot:item="items">
                <tr>
                    <td class="text-xs-left" style="width: 200px;">
                        <label class="text-truncate">
                            {{items.item.phone}}</label>
                    </td>
                    <td class="text-xs-left" style="width: 200px;">
                        <label class="text-truncate">
                            {{items.item.firstName}}</label>
                    </td>
                    <td class="text-xs-left" style="width: 200px;">
                        <label class="text-truncate">
                            {{identifyRequestStatus.titles[items.item.idRequestStatus]}}</label>
                    </td>
                    <td class="text-xs-left" style="width: 200px;">
                        <label class="text-truncate">{{items.item.email}}</label>
                    </td>
                    <td class="text-xs-left" style="width: 200px;">
                        <label class="text-truncate">{{items.item.countryTitle}}</label>
                    </td>
                    <td class="text-xs-left" style="width: 200px;">
                        <label class="text-truncate">{{items.item.phoneInfo1 || '-'}}</label>
                    </td>
                    <td class="text-xs-left" style="width: 200px;">
                        <label class="text-truncate">{{items.item.phoneInfo2 || '-'}}</label>
                    </td>
                    <td class="text-xs-left" style="width: 200px;">
                        <label class="text-truncate">{{items.item.createDate | createDate}}</label>
                    </td>
                    <td class="text-xs-right" style="width: 50px;">
                        <v-layout justify-center>
                            <v-btn icon title="Редактировать"
                                   @click="openItem(items.item)">
                                <v-icon color="primery">mdi-information</v-icon>
                            </v-btn>
                        </v-layout>
                    </td>
                </tr>
            </template>
        </v-data-table>

        <v-layout class="text-xs-center pt-2"
                  justify-center
                  align-center
                  style="width: 100%;">
            <v-fade-transition>
                <v-pagination v-model="page"
                              v-if="totalCount"
                              color="secondary"
                              style=" position: absolute; bottom: 15px;"
                              :total-visible="isMobile ? 3 : 7"
                              :length="pagesCount"/>
            </v-fade-transition>
        </v-layout>

        <v-dialog v-model="isVisibleEditModal"
                  :persistent="editLoading"
                  overlay-color="white"
                  overlay-opacity="0.5"
                  width="700">
            <seller-form :user="curItem"
                         :is-visible-edit-modal="isVisibleEditModal"
                         :edit-loading="editLoading"
                         @saveItem="saveItem($event)"
                         @updateSeller="updateSeller($event)"
                         @close="isVisibleEditModal = false"/>
        </v-dialog>
    </v-layout>
</template>

<script>
    import PaginationMixin from "../../mixins/PaginationMixin"
    import SellerForm from "./SellerForm"

    export default {
        name: "sellers-list",
        mixins: [PaginationMixin],
        components: {SellerForm},
        data: () => ({
            headers: [
                {
                    text: 'Номер телефона',
                    align: 'left',
                    sortable: false,
                    value: 'phone',
                },
                {
                    text: 'Имя',
                    align: 'left',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'Верификация',
                    align: 'left',
                    sortable: false,
                    value: 'isIdentified',
                },
                {
                    text: 'Почта',
                    align: 'left',
                    sortable: false,
                    value: 'email',
                },
                {
                    text: 'Страна',
                    align: 'left',
                    sortable: false,
                    value: 'country',
                },
                {
                    text: 'Доп. номер 1',
                    align: 'left',
                    sortable: false,
                    value: 'phoneInfo1',
                },
                {
                    text: 'Доп. номер 2',
                    align: 'left',
                    sortable: false,
                    value: 'phoneInfo2',
                },
                {
                    text: 'Зарегистрирован',
                    align: 'left',
                    sortable: false,
                    value: 'createDate',
                },
                {
                    text: '',
                    align: 'left',
                    sortable: false,
                    value: 'actions',
                }
            ],
            curItem: {},
            isVisibleEditModal: false,
            editLoading: false,
            phone: '',
            approve: false,
            xlsLoading: false
        }),
        computed: {
            width() {
                return this.$store.state.width
            },
            height() {
                return this.$store.state.height
            },
            isMobile() {
                return this.$store.state.isMobile
            },
            countTitles() {
                return ['запись', 'записей', 'записи']
            },
            usersCountLabel() {
                const count = this.totalCount;
                let index = 0;
                if (count) {
                    if (count > 9) index = 1;
                    else index = (count % 10 === 1) ? 0 : (count % 10 > 4) ? 1 : 2;
                    return `${count} ${this.countTitles[index]}`
                } else return 'Нет продавцов'
            },
            identifyRequestStatus() {
                return this.$store.state.identifyRequestStatus
            }
        },
        watch: {
            page(to) {
                const query = this.$route.query;
                this.$router.history.push({name: this.$route.name, query: {...query, page: to}})
                this.getItems()
            },
            '$route'(to) {
                this.getItems()
            },
            approve(to) {
                const query = this.$route.query;
                this.page = 1;
                this.$router.history.push({name: this.$route.name, query: {...query, page: this.page, approve: to}})
            }
        },
        methods: {
            getItems() {
                this.loading = true;
                const params = {
                    headers: {token: localStorage.getItem("token")},
                    params: {
                        page: this.page - 1,
                        limit: this.perPage,
                        searchString: this.phone,
                        approve: this.approve
                    }
                };
                console.log(params)
                this.$http.get("/sellers", params)
                    .then(response => {
                        this.items = response.data.data.sellers;
                        this.totalCount = response.data.data.count
                    }).catch(error => {
                    console.log(error)
                    switch (error.response.status) {
                        case 406:
                            // this.$router.history.push({name: 'login'})
                            break;
                        case 401:
                            this.$router.history.push({name: 'login'});
                            break;
                        default:
                            console.log('error');
                            break;
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            },
            openItem(item) {
                this.curItem = item;
                this.isVisibleEditModal = true
            },
            search() {
                const phone = this.phone;
                this.$router.history.push({name: 'sellers', query: {phone: phone, page: 1}})
            },
            saveXls() {
                this.xlsLoading = true;
                const params = {
                    headers: {
                        token: localStorage.getItem("token")
                    },
                    responseType: 'blob'
                }
                this.$http.post("/sellers/xls", {}, params)
                    .then(response => {
                          const url = window.URL.createObjectURL(new Blob([response.data]));
                          const link = document.createElement('a');
                          link.href = url;
                          link.setAttribute('target', '_blank');
                          link.setAttribute('download', 'Продавцы.xls');
                          link.click();
                    }).catch(error => {
                    console.log(error)
                    switch (error.response.status) {
                        case 406:
                            // this.$router.history.push({name: 'login'})
                            break;
                        case 401:
                            this.$router.history.push({name: 'login'});
                            break;
                        default:
                            console.log('error');
                            break;
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.xlsLoading = false
                    }, 500)
                })
            },
            updateSeller(data) {
                this.items.forEach(v => {
                    console.log(v.idSeller === data.idSeller)
                    if (v.idSeller === data.idSeller)
                        v[data.key] = data.value
                })
            },
            saveItem(item) {
                console.info('items: \n', this.items)
                console.info('data: \n', item)
                this.items.forEach(v => {
                    if (v.idSeller === item.idSeller) {
                        v.phone = item.phone;
                        v.isBlocked = item.isBlocked
                    }
                })
            }
        },
        sockets: {
            newRequest(data) {
                if (this.approve) this.getItems()
            }
        },
        beforeMount() {
            this.phone = this.$route.query.phone || '';
            this.page = parseInt(this.$route.query.page) || 1;
            this.approve = this.$route.query.approve === 'true';
        }
    }
</script>

<style scoped>
    .xls-button {
        margin-left: 200px;
        width: 280px;
        text-align: center;
        height: 50px;
        vertical-align: middle;
        border-radius: 8px;
    }

    .xls-button:hover, .xls-button *:hover {
        cursor: pointer;
    }
</style>